module.exports = __webpack_public_path__ + "static/media/warlock.56423788.png";